/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceContactIndividualType } from './ServiceContactIndividualType';
import {
	ServiceContactIndividualTypeFromJSON,
	ServiceContactIndividualTypeFromJSONTyped,
	ServiceContactIndividualTypeToJSON,
} from './ServiceContactIndividualType';

/**
 * A payload to update service contact in a client organization
 * @export
 * @interface UpdateServiceContact
 */
export interface UpdateServiceContact {
	/**
	 *
	 * @type {ServiceContactIndividualType}
	 * @memberof UpdateServiceContact
	 */
	contactType?: ServiceContactIndividualType;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof UpdateServiceContact
	 */
	metadataSchemaRID?: string;
	/**
	 *
	 * @type {object}
	 * @memberof UpdateServiceContact
	 */
	metadata?: object;
}

/**
 * Check if a given object implements the UpdateServiceContact interface.
 */
export function instanceOfUpdateServiceContact(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function UpdateServiceContactFromJSON(json: any): UpdateServiceContact {
	return UpdateServiceContactFromJSONTyped(json, false);
}

export function UpdateServiceContactFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): UpdateServiceContact {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		contactType: !exists(json, 'contactType')
			? undefined
			: ServiceContactIndividualTypeFromJSON(json['contactType']),
		metadataSchemaRID: !exists(json, 'metadataSchemaRID')
			? undefined
			: json['metadataSchemaRID'],
		metadata: !exists(json, 'metadata') ? undefined : json['metadata'],
	};
}

export function UpdateServiceContactToJSON(value?: UpdateServiceContact | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		contactType: ServiceContactIndividualTypeToJSON(value.contactType),
		metadataSchemaRID: value.metadataSchemaRID,
		metadata: value.metadata,
	};
}
